// components/ui/ModernInput.tsx
import React from 'react';

interface ModernInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const ModernInput: React.FC<ModernInputProps> = ({ 
  label, 
  error, 
  icon, 
  className = '',
  ...props 
}) => (
  <div className="space-y-1">
    {label && (
      <label className="block text-sm font-medium text-gray-700">
        {label}
      </label>
    )}
    <div className="relative">
      {icon && (
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          {icon}
        </div>
      )}
      <input
        {...props}
        className={`
          w-full px-4 py-3 ${icon ? 'pr-10' : ''} 
          border border-gray-300 rounded-xl
          focus:ring-2 focus:ring-blue-500 focus:border-transparent
          transition-all duration-200 bg-white
          placeholder-gray-400 text-gray-900
          ${error ? 'border-red-300 focus:ring-red-500' : ''}
          text-right
          ${className}
        `}
      />
    </div>
    {error && (
      <p className="text-sm text-red-600">{error}</p>
    )}
  </div>
);